import {TripCollection} from "../Trip";
import alba from "../../../assets/child/alba.jpg";


const dayChildAlba: TripCollection = {
    imageSrc: alba,
    trips: [
        {
            name: "2.1. Alba Iulia I",
            route: "Braşov – Alba Iulia – Braşov",
            days: [
                [
                    {
                        locationName: "Catedrala Reîntregirii Neamului",
                    },
                    {
                        locationName: "Catedrala Romano-Catolică “Sf. Mihail”",
                    },
                    {
                        locationName: "Sala Unirii",
                    },
                    {
                        locationName: "Traseul celor Trei Fortificaţii",
                    },
                ]
            ],
            notes: `Descoperiți bogata istorie și patrimoniul cultural într-o excursie memorabilă la Alba Iulia! Porniți cu o vizită la Catedrala Reîntregirii Neamului, o
            bijuterie arhitecturală ce marchează spiritul de unitate națională. Continuați
            călătoria cu o oprire la Catedrala Romano-Catolică "Sf. Mihail", o
            capodoperă a arhitecturii gotice din
            Transilvania. Apoi, explorați Sala Unirii, locul simbolic al unirii Principatelor
            Române în 1918, care a marcat momentul definitoriu al formării statului național român. Încheiați excursia cu
            Traseul celor Trei Fortificații, un parcurs istoric prin cetatea Alba Carolina.`
        },
        {
            name: "2.2. Alba Iulia II",
            route: "Braşov – Alba Iulia – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Catedrala Reîntregirii Neamului",
                        },
                        {
                            locationName: "Catedrala Romano-Catolică “Sf. Mihail”",
                        },
                        {
                            locationName: "Sala Unirii",
                        },
                        {
                            locationName: "Muzeul Principia",
                        },
                    ]
                ],
            notes:
                `Descoperiți bogata istorie și patrimoniul cultural într-o excursie memorabilă la Alba Iulia! Porniți cu o vizită la Catedrala Reîntregirii Neamului, o
            bijuterie arhitecturală ce marchează spiritul de unitate națională. Continuați
            călătoria cu o oprire la Catedrala Romano-Catolică "Sf. Mihail", o
            capodoperă a arhitecturii gotice din
            Transilvania. Apoi, explorați Sala Unirii, locul simbolic al unirii Principatelor
            Române în 1918, care a marcat momentul definitoriu al formării statului național român. La
            Muzeul Principia veți descoperi artefacte și exponate ce ilustrează istoria și cultura orașului antic. Această experiență va
            oferi elevilor o perspectivă profundă asupra bogatei moșteniri culturale și istorice a oraşului Alba Iulia.`
        }
        ,
    ]
}

export default dayChildAlba;